import React from 'react';
import { IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {httpRequest} from '../services/httpService';
import {useSnackbar} from "../contexts/SnackbarContext";
import { EmptyGuid } from '../utils/constants';

export default function FileUpload({onFileUpload, packageID, parentID, parentType}) {
    const showSnackbar = useSnackbar();
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            const base64Data = await new Promise((resolve, reject) => {
                fileReader.onload = () => {
                    const arrayBuffer = fileReader.result;
                    const bytes = new Uint8Array(arrayBuffer);
                    let binary = '';
                    bytes.forEach(byte => binary += String.fromCharCode(byte));
                    resolve(btoa(binary));
                };
                fileReader.onerror = reject;
            });

            const fileData = {
                data: base64Data,
                name: file.name
            };

            const res = await httpRequest(`/api/file?packageID=${packageID || EmptyGuid}&parentID=${parentID}&parentType=${parentType}`, {
                    method: 'POST',
                    body: fileData,
                    },
                showSnackbar,
                'Archivo subido');


            if (onFileUpload) {
                onFileUpload(res);
            }
        }
    };

    return (
        <label>
            <input
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            <IconButton color="primary" component="span">
                <CloudUploadIcon />
            </IconButton>
        </label>
    );
}